import React, { PropsWithChildren } from 'react';
import { layoutFooterLeftWrapperStyle } from './layout-footer-left.styles.css';

export const LayoutFooterLeft: React.FC<PropsWithChildren<unknown>> = ({
    children
}) => <div className={layoutFooterLeftWrapperStyle}>{children}</div>;
